module.exports = __webpack_public_path__ + "static/media/history.384d06ef.svg";